export const GET_TBILLTABLE_DATA = 'GET_TBILLTABLE_DATA';
export const ADD_NEW_TBILL_DATA = 'ADD_NEW_TBILL_DATA';
export const UPDATE_TBILLTABLE_DATA = 'UPDATE_TBILLTABLE_DATA';
export const VIEW_HISTORY = 'VIEW_HISTORY';

// For Ineligible Provider

export const GET_ALL_INELIGIBLLE_PROVIDER_DATA =
  'GET_ALL_INELIGIBLLE_PROVIDER_DATA';
export const HANDLE_ERROR_MESSAGE_MIP = 'HANDLE_ERROR_MESSAGE_MIP';
export const SET_GRID_DATA = 'SET_GRID_DATA';
export const SET_EDITED_DATA = 'SET_EDITED_DATA';
export const RESET_INELIGIBLE_PROVIDERS_STORE =
  'RESET_INELIGIBLE_PROVIDERS_STORE';
export const INELIGIBLE_PROV_RES = 'INELIGIBLE_PROV_RES';
export const SET_DELETED_DATA = 'SET_DELETED_DATA';
export const SET_NEW_PROVIDER_DATA = 'SET_NEW_PROVIDER_DATA';
export const CLEAR_REDUX_DATA_INELIGIBLE_PROVIDER =
  'CLEAR_REDUX_DATA_INELIGIBLE_PROVIDER';
export const CLEAR_TAB_STATE_INELIGIBLE_PROVIDER = 'CLEAR_TAB_STATE_INELIGIBLE_PROVIDER'
